import { createApp, ref, onMounted, watch, nextTick } from 'vue';
import { createPinia, storeToRefs } from 'pinia';
import layout from '@/style/layout.scss';
import $ from 'jquery';
import validate from '@global/vendors/jquery.validate.min';

import useMiniCartStore from '@global/stores/useMiniCartStore';
import useAlert from '@global/composable/useAlert';
import usePopup from '@global/composable/usePopup';
import useMsg from '@global/composable/useMessage';
import useAPIHandler from '@global/composable/api/useAxiosAPI';
import useModalStore from '@global/stores/useModalStore';

import NewImage from '@global/components/common/Image/NewImage.vue';
import AlertDialog from '@global/components/common/alert/AlertDialog.vue';
import Message from '@global/components/common/message/Message.vue';
import Popup from '@global/components/common/popup/Popup.vue';
import Modal from '@global/components/common/modal/Modal.vue';

import { fireSearchListEvent } from '@global/gtm/shopList/shopListView';
import fireSearchEvent from '@global/gtm/search';

import GlobalCtrl from './globalCtrl';

const pinia = createPinia();
const { alertDialog } = useAlert();
const { popupDialog } = usePopup();
const { messageBox } = useMsg();
const { postNewsletter } = useAPIHandler();

global.$ = require('jquery');

global.jQuery = global.$;
require('sticky-kit/dist/sticky-kit');

const app = createApp({
  components: {
    NewImage,
    AlertDialog,
    Popup,
    Message,
    Modal,
  },
  setup() {
    const miniCartStore = useMiniCartStore();
    const modalStore = useModalStore();
    const { modalName } = storeToRefs(modalStore);

    const {
      totalCount,
      generalCount,
      refrigerationCount,
      freezingCount,
      temperaturesData,
      dataIsLoad,
      count,
      hotSearch,
      hotLoad,
      isOnlyOneTemp,
    } = storeToRefs(miniCartStore);

    const { getCartInfo, getHotSearch } = miniCartStore;

    const cartContentHeight = ref('');
    const hasProduct = ref(0);
    const showProduct = ref(false);
    const hotInput = ref('');

    watch(totalCount, (val) => {
      onSetCartHeight();
    });

    watch(hotInput, (val) => {
      if (val === '') {
        $('#global-search').removeClass('focus');
        $('.hot-input-block').removeClass('open');
        $('.hot-cancel').css('display', 'none');
      }
    });

    watch(hotLoad, (val) => {
      if (val && window.location.pathname.includes('search')) {
        fireSearchListEvent(hotSearch.value);
      }
    });

    function onSetCartHeight() {
      if (totalCount.value !== 0) {
        if (isOnlyOneTemp.value && generalCount.value !== 0) {
          showProduct.value = true;
          if (temperaturesData.value[0].Markets.length > 4) {
            cartContentHeight.value = `${(4 * 68).toString()}px`;
            document.getElementById('miniCart-all').style.overflowY = 'scroll';
          } else {
            cartContentHeight.value = `${(
              temperaturesData.value[0].Markets.length * 68
            ).toString()}px`;
          }
          if (!document.getElementById('miniCart-all')) return;
          document.getElementById('miniCart-all').style.height = cartContentHeight.value;
        } else {
          if (generalCount.value !== 0) {
            hasProduct.value += 1;
          }

          if (refrigerationCount.value !== 0) {
            hasProduct.value += 1;
          }

          if (freezingCount.value !== 0) {
            hasProduct.value += 1;
          }
          cartContentHeight.value = `${(hasProduct.value * 55).toString()}px`;

          hasProduct.value = 0;
          if (!document.getElementById('miniCart-all')) return;
          document.getElementById('miniCart-all').style.height = cartContentHeight.value;
        }
      }
    }

    function goSearch(item) {
      window.location.href = `/search?Keyword=${item}`;

      fireSearchEvent({
        isHotSearch: true,
        keyword: item,
      });
    }

    function goInputSearch(event) {
      if ($('.hot-input').val().length === 0) {
        popupDialog.alert('請輸入文字', '貼心提醒');
        event.preventDefault();
      } else {
        window.location.href = `/search?Keyword=${$('.hot-input').val()}`;

        fireSearchEvent({
          isHotSearch: false,
          keyword: $('#global-search').val(),
        });
      }
    }

    function spread() {
      $('#global-search').addClass('focus');
      $('.hot-input-block').addClass('open');
      $('.hot-cancel').css('display', 'inline-block');
    }

    function cancel() {
      $('#global-search').removeClass('focus');
      $('.hot-input-block').removeClass('open');
      $('.hot-cancel').css('display', 'none');
      $('.hot-input').val('');
    }

    getCartInfo();
    getHotSearch();

    return {
      totalCount,
      generalCount,
      refrigerationCount,
      freezingCount,
      temperaturesData,
      dataIsLoad,
      count,
      hotSearch,
      hotLoad,
      isOnlyOneTemp,

      cartContentHeight,
      hasProduct,
      showProduct,
      hotInput,

      onSetCartHeight,
      goSearch,
      goInputSearch,
      spread,
      cancel,
      modalName,
    };
  },
});

app.use(pinia).mount('#app-mini-cart');
GlobalCtrl();

// 電子報

const mailValidate = {
  errorClass: 'error-text',
  errorElement: 'span',
  rules: {
    newsletter: {
      required: true,
      email: true,
    },
  },
  messages: {},
  errorPlacement(error, element) {
    element.parent().append(error);
  },
  submitHandler(form) {
    postNewsletter({
      Email: $('.footer__newsletter__txt').val(),
    })
      .then((res) => {
        if (res.data.Code === 200) {
          alertDialog.alert(res.data.Message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
};
$('#form-newsletter-signup').validate(mailValidate);

// 全域方法前後端使用
window.AlertDialog = alertDialog;
window.messageBox = messageBox;
